import { render } from "./ArrivalBoard.vue?vue&type=template&id=5f6b5f68&scoped=true"
import script from "./ArrivalBoard.vue?vue&type=script&lang=js"
export * from "./ArrivalBoard.vue?vue&type=script&lang=js"

import "./ArrivalBoard.vue?vue&type=style&index=0&id=5f6b5f68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f6b5f68"

export default script